import React, { useState, useRef, useEffect, useCallback } from "react";

import {
    Box,
    TextField,
    Grid,
    Button,
    styled,
    Divider,
    ImageList,
    ImageListItem,
    Typography,
    FormHelperText,
} from '@mui/material';

import { grey } from "@mui/material/colors";

import { useFormik } from 'formik';

import { CommonIcons, icons } from "../../../../../../components/common/CommonIcons";

import { useAuthAccess } from "../../../../../../hooks/useAuthAccess";
import { useAppContextFeatures } from "../../../../../../context/AppContext";
import { useSystemPrompt } from "../../../../../../hooks/useSystemPrompt";
import { useTranslations } from "../../../../../../hooks/useTranslations";

import {
    productInjectionProps,
    validationIdentitySchema,
    initialIdentityValues,
    useProduct,
    productImageTypes
} from "../../../../hooks/model/useProduct";

import {
    useProductImage
} from "../../../../hooks/model/useProductImage"

const StyledCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function UpdateProductIdentity({
    id,
    routeType,
    handleOnSuccess
}) {

    const { t } = useTranslations({ ns: ["_@products", "_prompt", "common", "_common"] })

    const { promptMessage } = useSystemPrompt();

    const { authData } = useAuthAccess(routeType)

    const { getProduct } = useProduct({ routeType })
    const { addProductNfcImage, getProductImage } = useProductImage({ routeType })

    const { checkIsOwnerUser } = useAuthAccess(routeType);

    const { setSystemLoading } = useAppContextFeatures();

    const [savedValues, setSavedValues] = useState()

    // only if owner account allow to update
    const [inputDisabled, setInputDisabled] = useState(
        checkIsOwnerUser() === false
    )

    const [inputFile, setInputFile] = useState({
        mainState: "initial", // initial
        imageUploaded: 0,
        selectedFile: "",
        source: {}
    })

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const loadData = useCallback(async (id) => {

        setSystemLoading(true)

        try {

            const data = await getProduct({ id })

            // console.log('data', data, sampleIdentityJSON)
            // const { branch } = data;

            let {
                product
            } = data

            // setSavedValues({
            //     ...initialValues,
            //     // name: product[productInjectionProps.nfcPersonName.retrieveKey],
            //     // identityNo: product[productInjectionProps.nfcIdentityNo.retrieveKey],
            //     name: sampleIdentityJSON?.name,
            //     identityNo: sampleIdentityJSON?.id,
            //     sex: sampleIdentityJSON?.sex,
            //     nation: sampleIdentityJSON?.nation,
            //     dob: sampleIdentityJSON?.birth,
            //     address: sampleIdentityJSON?.address,
            //     department: sampleIdentityJSON?.depart,
            //     validityTime: sampleIdentityJSON?.validityTime,
            //     imageBase64: sampleIdentityJSON?.imageBase64
            // })

            let nfcFileId = product[productInjectionProps.nfcFileId.retrieveKey]
            let nfcDetails = product[productInjectionProps.nfcDetails.retrieveKey]

            // console.log('nfcFileId', nfcFileId)

            nfcDetails = JSON.parse(nfcDetails)

            // console.log('nfcDetails', nfcDetails)

            // get the file id if exist
            let fileInfo = {}
            if (nfcFileId && nfcFileId !== 0 && nfcFileId !== "0") {
                // fileInfo = await fetchFile({ fileId: nfcFileId })
                fileInfo = await getProductImage({ id: nfcFileId })
                // console.log('fileInfo', fileInfo)
            }

            let imageBase64 = ""

            let b = {
                ...initialIdentityValues,
                name: product[productInjectionProps.nfcPersonName.retrieveKey] ? product[productInjectionProps.nfcPersonName.retrieveKey] : "",
                identityNo: product[productInjectionProps.nfcIdentityNo.retrieveKey] ? product[productInjectionProps.nfcIdentityNo.retrieveKey] : "",
                imageBase64,
                sex: nfcDetails?.sex ? nfcDetails.sex : "",
                nation: nfcDetails?.nation ? nfcDetails.nation : "",
                dob: nfcDetails?.dob ? nfcDetails.dob : "",
                address: nfcDetails?.address ? nfcDetails.address : "",
                department: nfcDetails?.department ? nfcDetails.department : "",
                validityTime: nfcDetails?.validityTime ? nfcDetails.validityTime : "",
                fileUrl: fileInfo?.file_url
            }

            // console.log('b', b)

            setSavedValues(b)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            let nfcDetails = {}

            Object.keys(currentValues).forEach(i => {
                if (i !== `imageBase64`) {
                    nfcDetails[i] = currentValues[i]
                }
            })

            let payload = {
                productId: id,
                lastUpdateUserId: `${authDataUserId}`,
                lastUpdateUserDisplay: `${authDataUserDisplay}`,
                inputFile,
                imageType: productImageTypes.nfcImage.typeValue,
                imageTag: productImageTypes.nfcImage.tagValue,
                nfcIdentityNo: currentValues?.identityNo,
                nfcPersonName: currentValues?.name,
                nfcDetails: JSON.stringify(nfcDetails)
            }

            let response = await addProductNfcImage(payload)

            // let newFileId = ''

            // if (inputFile?.selectedFile) {

            //     // have to search the files to removed for previously
            //     let existingFiles = await fetchFiles({ referId: id })

            //     let deleteFileIds = existingFiles.map(i => i.id)

            //     if (deleteFileIds.length > 0) {
            //         await deleteFiles({ fileIds: deleteFileIds })
            //     }

            //     let fileName = inputFile?.source?.fileName
            //     let base64 = inputFile?.selectedFile

            //     let fileExtension = fileName.split('.').pop();
            //     let newFileName = `${id}.${fileExtension}` // use product id as file name

            //     // base64 = base64.toString().replace('data:image/png;base64,', '')

            //     base64 = base64.toString().split(',').pop();

            //     // console.log('base64', base64)

            //     let dataFile = {
            //         file: {
            //             base64_attachments: [
            //                 {
            //                     ...initialFileValues,
            //                     module: fileModuleTypes.item.product.value, /* required */
            //                     file_ref: fileReferenceTypes.item.product.value, /* required */
            //                     type: productImageTypes.nfcImage.typeValue, /* required */
            //                     tag: productImageTypes.nfcImage.tagValue,
            //                     name: `${newFileName}`, /* required */
            //                     description: `Identity No. : ${currentValues?.identityNo} / Name : ${currentValues?.name}`,
            //                     refer_id: id, /* required */
            //                     base64_code: base64
            //                 }
            //             ]
            //         }
            //     }

            //     let response = await createFile({ data: dataFile })

            //     // get the file id
            //     newFileId = response?.data?.upload_results[0]?.file.id

            //     setSystemLoading(false)

            //     // console.log('response', response)
            // }

            // let nfcDetails = {}

            // Object.keys(currentValues).forEach(i => {
            //     if (i !== `imageBase64`) {
            //         nfcDetails[i] = currentValues[i]
            //     }
            // })

            // let targetInjectionPropIds = [
            //     `nfcPersonName`,
            //     `nfcIdentityNo`,
            //     `nfcDetails`
            // ]

            // let nfcInfo = {
            //     nfcPersonName: currentValues?.name,
            //     nfcIdentityNo: currentValues?.identityNo,
            //     nfcDetails: JSON.stringify(nfcDetails),
            // }

            // // if the file id uploaded only override this injection props
            // if (newFileId !== '') {
            //     targetInjectionPropIds = [
            //         ...targetInjectionPropIds,
            //         `nfcFileId`,
            //     ]
            //     nfcInfo = {
            //         ...nfcInfo,
            //         nfcFileId: newFileId,
            //     }
            // }

            // // // append inj props - for existing product only for nfc details
            // let injectionPropsLoaded = createProductInjectionPropsPayload({
            //     productId: id,
            //     barcode: ``,
            //     data: {},
            //     mainData: {},
            //     targetInjectionPropIds,
            //     nfcInfo
            // })

            // let dataInjectionProps = {
            //     injection_props: injectionPropsLoaded
            // }

            // const response = await createItemInjectionProps({ data: dataInjectionProps, targetType: injectionPropTargetTypes.item.id })

            // promptMessage(true, `${response?.message}`)
            promptMessage(true, `${t("productImagesSaved")}`)

            if (handleOnSuccess) handleOnSuccess()

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

        setSystemLoading(false)
    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema: validationIdentitySchema,
        enableReinitialize: true,
        onSubmit
    });

    const { touched, values, errors, handleChange, handleSubmit, setFieldValue } = formik;

    useEffect(() => {
        loadData(id)
    }, [])

    const handleUploadClick = (event) => {

        let file = event.target.files[0];

        const reader = new FileReader();
        let url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {
            // console.log('loaded', file?.name)
            // console.log('JSON.stringify(file)', JSON.stringify(file))
            setInputFile(prev => ({
                ...prev,
                selectedFile: [reader.result],
                source: {
                    fileName: file?.name
                }
            }));
        };

    };

    const RenderSavedImage = () => {

        if (values.fileUrl && values?.fileUrl !== 0) {
            return (
                <img
                    src={`${values?.fileUrl}`}
                    alt={values?.identityNo}
                    style={{
                        maxWidth: 400,
                        maxHeight: 200,
                        marginBottom: 10
                    }}
                />
                // <img
                //     srcSet={`${getImage()}?w=100&h=100&fit=crop&auto=format&dpr=2 2x`}
                //     src={`${getImage()}?w=100&h=100&fit=crop&auto=format`}
                //     alt={"Identity Card"}
                //     loading="lazy"
                // />
            )
        }
        return (
            <CommonIcons
                name={icons.blank}
                sx={{
                    width: 100,
                    height: 100
                }}
            />
        )
    }

    const RenderPreviewImage = () => {

        let base64 = inputFile?.selectedFile

        if (base64) {
            return (
                <img
                    src={`${base64}`}
                    alt={`Preview`}
                    style={{
                        maxWidth: 400,
                        maxHeight: 200,
                        marginBottom: 10
                    }}
                />
                // <img
                //     srcSet={`${getImage()}?w=100&h=100&fit=crop&auto=format&dpr=2 2x`}
                //     src={`${getImage()}?w=100&h=100&fit=crop&auto=format`}
                //     alt={"Identity Card"}
                //     loading="lazy"
                // />
            )
        }

        return (
            <CommonIcons
                name={icons.blank}
                sx={{
                    width: 100,
                    height: 100
                }}
            />
        )
    }

    const RenderImagePanel = () => {
        return (
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
            >

                <Box>
                    <Typography>
                        {t('previewImage')}
                    </Typography>
                    <RenderPreviewImage />
                </Box>

                {/* <Button variant="contained" component="span"> */}
                {/* Select Image */}
                <input
                    disabled={
                        inputDisabled
                    }
                    accept="image/*"
                    // className={classes.input}
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={handleUploadClick}
                    style={{
                        // backgroundColor: 'red',
                        borderColor: grey[500],
                        borderWidth: 1,
                        borderStyle: 'solid',
                        padding: 5
                    }}
                />
                {/* </Button> */}
            </Box>
        )
    }

    const RenderForm = () => {

        if (!values) return <></>

        return (

            <form onSubmit={handleSubmit}>
                {/* {JSON.stringify(values)} */}
                <StyledCard>
                    <Grid container spacing={1}>

                        {/* <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                            <CommonSectionHeader
                                title={'Product handle by Identity'}
                            />
                        </Grid> */}

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                            <Grid container spacing={1}>

                                <Grid item xs={12} sm={12} md={6}
                                    display={"flex"}
                                    flexDirection={"row"}
                                    alignItems={"flex-start"}
                                    justifyContent={"center"}
                                >
                                    <Box>
                                        <Typography>
                                            {t('currentImage')}
                                        </Typography>
                                        <RenderSavedImage />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}
                                // display={"flex"}
                                // flexDirection={"column"}
                                // alignItems={"flex-start"}
                                // justifyContent={"center"}
                                >
                                    <RenderImagePanel />
                                    {/* <FormHelperText
                                        error={Boolean(errors?.imageBase64)}
                                    >
                                        {errors?.imageBase64}
                                    </FormHelperText> */}
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"name"}
                                        label={t('name')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.name}
                                        onChange={handleChange}
                                        error={Boolean(errors?.name)}
                                        helperText={errors?.name}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"sex"}
                                        label={t('gender')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.sex}
                                        onChange={handleChange}
                                        error={Boolean(errors?.sex)}
                                        helperText={errors?.sex}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"nation"}
                                        label={t('nation')}
                                        variant="outlined"
                                        value={values?.nation}
                                        onChange={handleChange}
                                        error={Boolean(errors?.nation)}
                                        helperText={errors?.nation}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"dob"}
                                        label={t('dateOfBirth')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.dob}
                                        onChange={handleChange}
                                        error={Boolean(errors?.dob)}
                                        helperText={errors?.dob}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"identityNo"}
                                        label={t('identityNo')}
                                        variant="outlined"
                                        value={values?.identityNo}
                                        onChange={handleChange}
                                        error={Boolean(errors?.identityNo)}
                                        helperText={errors?.identityNo}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"department"}
                                        label={t('department')}
                                        variant="outlined"
                                        value={values?.department}
                                        onChange={handleChange}
                                        error={Boolean(errors?.department)}
                                        helperText={errors?.department}
                                    />
                                </Grid>


                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"address"}
                                        label={t('address')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.address}
                                        onChange={handleChange}
                                        error={Boolean(errors?.address)}
                                        helperText={errors?.address}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                        disabled={
                                            inputDisabled
                                        }
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"validityTime"}
                                        label={t('validityTime')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.validityTime}
                                        onChange={handleChange}
                                        error={Boolean(errors?.validityTime)}
                                        helperText={errors?.validityTime}
                                    />
                                </Grid>

                            </Grid>

                        </Grid>


                        <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                            <Grid item md={12} textAlign={"left"}>
                                <Button
                                    type="submit"
                                    disabled={
                                        inputDisabled
                                    }
                                    // fullWidth
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2
                                    }}
                                >
                                    {t('saveChanges')}
                                </Button>
                            </Grid>
                        </Grid>

                    </Grid>
                </StyledCard>
            </form>

        )
    }

    return (
        <Box>

            {/* {JSON.stringify(inputFile?.source)} */}
            {
                RenderForm()
            }

        </Box>
    )
}